import { ServiceFactoryClientExecuteApi } from '../Common/Services/ServiceFactoryToExecuteApi';
import { UATConstants, HttpVerbs } from '../Common/Models/UATConstants';
import { fetchMsGraphProfilePic, GRAPH_ENDPOINTS } from '../auth-utils';

export class UsercardService {
  /**
   * @function
   * Returns user results after a REST API call
   */
  public static GetPersonaDetails = async (uniqueName: string) => {
    const url = `${UATConstants.ApiPaths.PersonDetails}?aliases=${uniqueName}`;
    return ServiceFactoryClientExecuteApi.ExecuteRequestAsync(url, [], HttpVerbs.get, []);
  };

  public static async getProfilePhoto(userPrincipalName: string) {
    const graphToken = sessionStorage.getItem(UATConstants.jwtTokenForGraph);
    return fetchMsGraphProfilePic(
      GRAPH_ENDPOINTS.USER + userPrincipalName + '/photo/$value',
      graphToken
    );
  }

  public static getUserAlias = async (userId: string) => {
    const url = `${UATConstants.ApiPaths.GetAlias}?userId=${userId}`;
    return ServiceFactoryClientExecuteApi.ExecuteRequestAsync(url, [], HttpVerbs.get, []);
  };
}
